import api from './api';
import { Temple, PaginatedResponse } from '../types';

interface TempleFilters {
  search?: string;
  deaneryId?: string;
  isActive?: boolean;
  page?: number;
  limit?: number;
}

export const templesService = {
  async getList(filters: TempleFilters = {}): Promise<PaginatedResponse<Temple>> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.deaneryId) params.append('deaneryId', filters.deaneryId);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Temple>>('/temples', { params });
    return response.data;
  },

  async getById(id: number): Promise<Temple> {
    const response = await api.get<Temple>(`/temples/${id}`);
    return response.data;
  },

  async getBySlug(slug: string): Promise<Temple> {
    const response = await api.get<Temple>(`/temples/slug/${slug}`);
    return response.data;
  },

  async create(data: Omit<Temple, 'id' | 'createdAt' | 'updatedAt'>): Promise<Temple> {
    const response = await api.post<Temple>('/temples', data);
    return response.data;
  },

  async update(id: number, data: Partial<Temple>): Promise<Temple> {
    const response = await api.put<Temple>(`/temples/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/temples/${id}`);
  },

  async toggleActive(id: number): Promise<Temple> {
    const response = await api.post<Temple>(`/temples/${id}/toggle-active`);
    return response.data;
  },
};
